import classNames from 'classnames/bind';
import React, { PureComponent } from 'react';
import {
  Button, Card, Spinner,
} from 'react-bootstrap';
import { StepTypes } from '../../../dorian-shared/types/branch/BranchStep';
import { api } from '../../api';
import { BranchContent } from './BranchContent';
import { ChangeColor } from './ChangeColor';
import { ConnectionButton } from './ConnectionButton';
import { DeleteBranch } from './DeleteBranch';
import { EditName } from './EditName';
import { PortalDropdownMenu } from './PortalDropdownMenu';
import styles from './StoryBranches.scss';

const cs = classNames.bind(styles);

export class BranchItem extends PureComponent {
  constructor(props, ...args) {
    super(props, ...args);
    const { branchNode, newBranchId } = this.props;

    this.brancheNameForm = React.createRef();
    this.refFormControl = React.createRef();
    this.ellipsisToggleRef = React.createRef();
    const editName = !!(newBranchId && newBranchId === branchNode.id);
    this.state = {
      modalDeleteBranchShow: false,
      editName,
      isLoading: false,
      ellipsisMenuOpen: false,
    };

    this.toggleEllipsisMenu = () => this.setState((s) => ({ ellipsisMenuOpen: !s.ellipsisMenuOpen }));
    this.closeEllipsisMenu = () => this.setState({ ellipsisMenuOpen: false });
  }

  componentDidMount() {
    const { editName } = this.state;
    const { onEdit } = this.props;
    if (editName) {
      this.startEditName();
      onEdit?.(editName);
    }
  }

  componentWillUnmount() {
    this.stopEditName();
  }

  componentDidUpdate(prevProps, prevState) {
    const { editName } = this.state;
    const { onEdit } = this.props;

    if (prevState.editName !== editName) {
      if (editName) {
        this.startEditName();
      } else {
        this.stopEditName();
      }

      if (onEdit) {
        onEdit(editName);
      }
    }
  }

  handleClickOutside = (event) => {
    const { editName } = this.state;
    const area = this.refFormControl.current;
    if (area && !area.contains(event.target) && editName) {
      this.brancheNameForm.current.click();
    }
  };

  escFunction = (event) => {
    const { editName } = this.state;

    if (event.keyCode === 27 && editName) {
      this.setState({
        editName: false,
      });
    }
  };

  stopEditName = () => {
    document.removeEventListener('click', this.handleClickOutside, false);
    document.removeEventListener('keydown', this.escFunction, false);
  };

  startEditName = () => {
    document.addEventListener('click', this.handleClickOutside, { passive: true });
    document.addEventListener('keydown', this.escFunction, { passive: true });
  };

  updateBranch = (arr) => {
    const { branchNode, storyId, onError } = this.props;

    this.setState({ isLoading: true });

    api.patch(`/v1/stories/${storyId}/branches/${branchNode.id}`, arr)
      .then(() => {
        localStorage.setItem(`lastEdit-${storyId}`, branchNode.id);
        this.update();
      })
      .catch((error) => {
        if (onError) {
          onError(error);
        }
      })
      .finally(() => {
        this.setState({
          editName: false,
          isLoading: false,
        });
      });
  };

  isIntro = () => {
    const { branchNode } = this.props;

    return branchNode.title === 'intro';
  };

  clearSelection = () => {
    const { clearSelection, branchNode } = this.props;

    if (clearSelection) {
      clearSelection([branchNode.id]);
    }
  };

  update = () => {
    const { update, branchNode } = this.props;

    if (update) {
      update(branchNode);
    }
  };

  handleDelete = () => {
    const { onDeleteSuccess } = this.props;
    onDeleteSuccess();
    this.setState({ modalDeleteBranchShow: false });
  };

  render() {
    const {
      disabled,
      duplicate,
      branchNode,
      selectCascade,
      storyId,
      storyGroup,
      actionEditBranch,
      isAnalyticsVisible,
      isCheckStep,
      memorySlotData,
      isLastEdit,
      compact,
    } = this.props;

    const {
      editName,
      modalDeleteBranchShow,
      modalChangeColorBranchShow,
      isLoading,
      ellipsisMenuOpen,
    } = this.state;

    const decisionPoint = branchNode.links && branchNode.links.length > 0;

    const modalChangeColorBranchClose = () => {
      this.setState({ modalChangeColorBranchShow: false });
      this.update();
    };

    const changeColorBranch = () => {
      if (modalChangeColorBranchShow !== true) {
        return null;
      }

      return (
        <ChangeColor
          storyId={storyId}
          show={modalChangeColorBranchShow}
          onHide={modalChangeColorBranchClose}
          obj={branchNode}
        />
      );
    };

    const cardBodyStyle = branchNode.bgColor ? { backgroundColor: branchNode.bgColor } : {};
    const hasHubStep = branchNode.steps?.some((s) => Number(s.stepTypeId) === StepTypes.Hub);

    return (
      <Card
        className={cs(
          'text-center m-1 branchesItems branchesItemsLong',
          this.isIntro() ? 'branch_intro' : `branch_${branchNode.type}`,
          branchNode.bonus_content ? 'branch_gold' : null,
          editName ? 'branchEdit' : null,
          decisionPoint || isCheckStep || hasHubStep ? 'branchesDecsionPoint' : null,
          isCheckStep ? 'branch_check' : null,
          hasHubStep ? 'branch_hub' : null,
          isLastEdit ? 'lastEdit' : null,
          compact ? 'branchItemCompact' : null,
        )}
      >
        <Card.Body style={cardBodyStyle}>
          <Card.Title
            className="mb-1 p-0"
            onDoubleClick={(e) => {
              if (!disabled && !this.isIntro()) {
                e.stopPropagation();
                this.setState({
                  editName: true,
                });
              }
            }}
          >
            {!isLoading && !editName && (
              <span
                className={cs('branchTitleText')}
                style={{ backgroundColor: branchNode.bgColor || '#fff' }}
              >
                {branchNode.title}
              </span>
            ) }
            {!isLoading && editName && (
              <EditName
                {...this.props}
                refFormControl={this.refFormControl}
                brancheNameForm={this.brancheNameForm}
                handleSubmit={this.updateBranch}
              />
            )}
            {isLoading && (
              <div>
                <Spinner animation="border" variant="primary" />
                <div className="editNameBg" />
              </div>
            )}
            {decisionPoint ? 'Decision Point' : null}
          </Card.Title>

          {!compact && (
            <Card.Text
              as="div"
              className={cs('cardBranchContent', isAnalyticsVisible ? 'showAnalytic' : null)}
            >
              <BranchContent
                storyGroup={storyGroup}
                branchNode={branchNode}
                isAnalyticsVisible={isAnalyticsVisible}
                memorySlotData={memorySlotData}
              />
            </Card.Text>
          )}

        </Card.Body>
        <Card.Footer className="not-selectable">
          {(!isAnalyticsVisible || !disabled) && (
            <ConnectionButton
              {...this.props}
              disabled={disabled}
            />
          )}

          <Button
            type="reset"
            variant="outline-dark"
            size="sm"
            className="mx-1"
            data-testid="branch-edit"
            onClick={() => {
              this.clearSelection();
              if (actionEditBranch) {
                actionEditBranch(branchNode);
              }
            }}
          >
            Edit
          </Button>

          {(!isAnalyticsVisible || disabled) && (
            <div className="mx-1 d-inline-block">
              <Button
                ref={this.ellipsisToggleRef}
                variant="outline-dark"
                size="sm"
                className="mx-1 dropdown-toggle"
                onClick={this.toggleEllipsisMenu}
              >
                ...
              </Button>
              <PortalDropdownMenu
                show={ellipsisMenuOpen}
                toggleRef={this.ellipsisToggleRef}
                onClose={this.closeEllipsisMenu}
              >
                <button
                  type="button"
                  role="menuitem"
                  className="dropdown-item"
                  disabled={disabled}
                  onClick={() => {
                    this.setState({ modalChangeColorBranchShow: true, ellipsisMenuOpen: false });
                  }}
                >
                  Color
                </button>
                <button
                  type="button"
                  role="menuitem"
                  className="dropdown-item"
                  disabled={disabled}
                  onClick={() => {
                    duplicate([branchNode.id]);
                    this.setState({ ellipsisMenuOpen: false });
                  }}
                >
                  Duplicate
                </button>
                <button
                  type="button"
                  role="menuitem"
                  className="dropdown-item"
                  disabled={disabled}
                  onClick={() => {
                    selectCascade(branchNode.id);
                    this.setState({ ellipsisMenuOpen: false });
                  }}
                >
                  Select cascade
                </button>

                <div className="dropdown-divider" role="separator" />
                <button
                  type="button"
                  role="menuitem"
                  className="dropdown-item"
                  disabled={disabled || this.isIntro()}
                  onClick={() => {
                    this.setState({ modalDeleteBranchShow: true, ellipsisMenuOpen: false });
                  }}
                >
                  Delete
                </button>
              </PortalDropdownMenu>
            </div>
          )}
          <DeleteBranch
            show={modalDeleteBranchShow}
            storyId={storyId}
            branches={[branchNode]}
            onDelete={this.handleDelete}
            onCancel={() => this.setState({ modalDeleteBranchShow: false })}
          />
          {changeColorBranch()}
        </Card.Footer>
      </Card>
    );
  }
}
